export default __webpack_public_path__ + "talaris-icon-969130732d6ad0f3ff16b3661a071613.png";